import {ChangeEvent, useMemo} from "react";
import {useTranslation} from "react-i18next";
import WithTooltip from "../../ui/tooltip";
import classes from "./UserEmotionSelect.module.css";
import {UserEmotion} from "../../schema";
import {UserEmotionEmoji} from "./UserEmotionEmoji";

type props = {
  name?: string;
  value?: string;
  onChange?: (e: ChangeEvent) => void;
};

export default function UserEmotionSelect({name, value, onChange}: props) {
  const {t} = useTranslation();

  const choices = useMemo(
    () => [
      {
        value: "",
        label: t("types.UserEmotion.no emotion"),
        emoji: "😶",
      },
      {
        value: UserEmotion.NEUTRAL,
        label: t("types.UserEmotion.NEUTRAL"),
        emoji: UserEmotionEmoji.NEUTRAL,
      },
      {
        value: UserEmotion.JOY,
        label: t("types.UserEmotion.JOY"),
        emoji: UserEmotionEmoji.JOY,
      },
      {
        value: UserEmotion.ENTHUSIASM,
        label: t("types.UserEmotion.ENTHUSIASM"),
        emoji: UserEmotionEmoji.ENTHUSIASM,
      },
      {
        value: UserEmotion.ANGER,
        label: t("types.UserEmotion.ANGER"),
        emoji: UserEmotionEmoji.ANGER,
      },
      {
        value: UserEmotion.GUILT,
        label: t("types.UserEmotion.GUILT"),
        emoji: UserEmotionEmoji.GUILT,
      },
      {
        value: UserEmotion.SHAME,
        label: t("types.UserEmotion.SHAME"),
        emoji: UserEmotionEmoji.SHAME,
      },
      {
        value: UserEmotion.FEAR,
        label: t("types.UserEmotion.FEAR"),
        emoji: UserEmotionEmoji.FEAR,
      },
      {
        value: UserEmotion.DISGUST,
        label: t("types.UserEmotion.DISGUST"),
        emoji: UserEmotionEmoji.DISGUST,
      },
      {
        value: UserEmotion.SADNESS,
        label: t("types.UserEmotion.SADNESS"),
        emoji: UserEmotionEmoji.SADNESS,
      },
      {
        value: UserEmotion.SURPRISE,
        label: t("types.UserEmotion.SURPRISE"),
        emoji: UserEmotionEmoji.SURPRISE,
      },
    ],
    [t],
  );

  return (
    <div className={classes.root}>
      {choices.map((choice) => (
        <WithTooltip key={choice.value} as="label" className={classes.itemWrapper} helpText={choice.label}>
          <input
            className={classes.input}
            type="radio"
            name={name}
            checked={choice.value === (value ?? "")}
            value={choice.value}
            onChange={onChange}
          />
          <div className={classes.item}>{choice.emoji}</div>
        </WithTooltip>
      ))}
    </div>
  );
}
